document.addEventListener('DOMContentLoaded', function() {
    const button = document.querySelector('.installation-button');
    const openList = document.querySelector('.installation-block-open-list');
    const buttonText = document.querySelector('.installation-button-text');
    
    if (button && openList && buttonText) {
        button.addEventListener('click', function() {
            const isOpen = openList.classList.contains('open');
            
            if (isOpen) {
                // Close: get current height (handle 'auto' case)
                let currentHeight = openList.scrollHeight;
                if (openList.style.height === 'auto' || !openList.style.height) {
                    currentHeight = openList.scrollHeight;
                } else {
                    currentHeight = parseInt(openList.style.height) || openList.scrollHeight;
                }
                
                openList.style.height = currentHeight + 'px';
                // Force reflow to ensure height is set
                openList.offsetHeight;
                // Now animate to 0
                requestAnimationFrame(function() {
                    openList.style.height = '0px';
                });
                openList.classList.remove('open');
                button.classList.remove('open');
                buttonText.textContent = 'READ MORE';
            } else {
                // Open: ensure height is 0, add open class, then animate to full height
                openList.style.height = '0px';
                openList.classList.add('open');
                button.classList.add('open');
                buttonText.textContent = 'READ LESS';
                // Force reflow
                openList.offsetHeight;
                // Now animate to full height
                const targetHeight = openList.scrollHeight;
                requestAnimationFrame(function() {
                    openList.style.height = targetHeight + 'px';
                });
            }
        });
        
        // Handle transition end to clean up inline styles when open
        openList.addEventListener('transitionend', function() {
            if (openList.classList.contains('open')) {
                openList.style.height = 'auto';
            }
        });
    }
});

